import { styled } from '@mui/material/styles';
import _Overflow from 'rc-overflow';

export const Overflow = styled(_Overflow)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));
